module.exports = __webpack_public_path__ + "assets/alertIcon.a9bd60c3.svg";